import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/global.scss'
import '@/assets/css/theme.scss'
import '@/assets/css/theme-dark.css'
import '@/assets/css/global.css'
import '@/assets/css/webcommon.css'
import '@/assets/css/action-buttons.scss'
import request from './utils/request'
import filters from './utils/filters'
import permissionMixin from './directives/permission'
import deviceControl from './js/device-control'

Vue.use(ElementUI)

// 注册全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// 权限缓存（全局共享）
let _permCache = []
const refreshPermCache = () => {
  try {
    _permCache = JSON.parse(localStorage.getItem('permissions') || '[]')
  } catch (e) {
    _permCache = []
  }
}
refreshPermCache()

// 全局权限判断方法
Vue.prototype.$hasPerm = (perm) => {
  if (_permCache.includes('*:*:*')) return true
  if (Array.isArray(perm)) {
    return perm.some(p => _permCache.includes(p))
  }
  return _permCache.includes(perm)
}

// 权限 mixin（组件内可直接 this.hasPerm()）
Vue.mixin(permissionMixin)

// 刷新权限缓存方法挂载到实例
Vue.prototype.$refreshPermCache = refreshPermCache

// 挂载 axios 实例
Vue.prototype.$axios = request

// 设备控制插件
Vue.use(deviceControl)

Vue.config.productionTip = false

// 初始化主题（避免页面闪烁）
if (localStorage.getItem('theme') === 'dark' || localStorage.getItem('theme') === null) {
  document.body.classList.add('dark-theme')
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
